import { useEffect, useState } from "react";

/**
 * Debounce a value by `delay` ms. The returned value lags the input
 * until `delay` has elapsed without a change.
 *
 * Extracted from the inline timer in `ContactSearch.jsx` so both
 * `ContactSearch` (form-embedded search, 300ms) and the new
 * `ContactsDirectory` (page-level search, 250ms) share one
 * implementation. Per Brief #3 Block 3: "This is the only refactor
 * permitted in ContactSearch.jsx."
 *
 * @param {*}        value Any value (typically a string).
 * @param {number}   delay Debounce window in ms.
 * @returns the latest stable value.
 */
export function useDebouncedValue(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

export default useDebouncedValue;
